module.exports = __webpack_public_path__ + "media/intuition.2e27feec.ogg";